import store from '@/store';
import { EngagementModel } from '@etp/etp-engagements-client/axios';

export default {
  async signIn(): Promise<void> {
    const postLoginRedirectUri = encodeURIComponent(
      window.location.origin + process.env.BASE_URL + 'overview'
    );
    window.location.href = `/authorization/login?postLoginRedirect=${postLoginRedirectUri}`;
  },
  async signOut(): Promise<void> {
    return new Promise(resolve => {
      store.commit('home/SET_CURRENT_ENGAGEMENT', {} as EngagementModel);
      const postLogoutRedirectUri = encodeURIComponent(
        window.location.origin + process.env.BASE_URL
      );
      window.location.href = `/authorization/logout?postLogoutRedirect=${postLogoutRedirectUri}`;
      resolve();
    });
  }
};
